import React from 'react'

const EjercicioDerechos = () => {
  return (
    <section>
      <div className='tw-mt-8 tw-mt-8@lg tw-mb-8 tw-mb-8@lg'>
        <h2 className='font-family-secondary c-gray--4 fw-7 tw-m-0 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-4@lg'>
          Ejercicio de derechos por el titular de datos personales
        </h2>
        <p className="font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg">
          Puedes ejercer los derechos de acceso/información, rectificación,
          cancelación, revocatoria y oposición (Derechos ARCO) ingresando a la
          opción de “Solicitud de atención de Derechos ARCO” en la sección Mis
          Trámites de mi Agencia Virtual a través del enlace{" "}
          <a
            className="c-orange-0 b underline"
            target="_blank"
            rel="noopener noreferrer"
            href="https://miespacio.prima.com.pe/"
          >
            https://miespacio.prima.com.pe/
          </a>{' '}
          . Si eres representante legal de un
          afiliado, deberás ingresar a{" "}
          <a
            className="c-orange-0 b underline"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.prima.com.pe/public-zone/"
          >
            https://www.prima.com.pe/public-zone/
          </a>{' '}
          y, entrar al apartado de “Regístrate” para crear tu usuario, de manera
          previa al trámite. Si no eres cliente, llámanos a Fono Prima en Lima
          al (01) 615-7272 y en Provincias al 0801-1-8010. En caso tu pedido no
          haya sido atendido puedes presentar un reclamo ante la Autoridad
          Nacional de Protección de Datos Personales, dirigiéndote a la Mesa de
          Partes del Ministerio de Justicia y Derechos Humanos (Calle Scipion
          Llona 350, Miraflores, Lima, Perú).
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          No olvides que deberás presentar tu documento de identidad (DNI/CE/Pasaporte) para 
          validar que eres el titular. Si utilizas un representante legal, éste deberá estar 
          acreditado como tal, es decir, deberá presentar el poder o título que confirme que 
          se encuentra autorizado para ejercer cualquiera de estos derechos en tu representación. 
          Tú o tu representante deberán llenar la “Solicitud de atención de derechos protegidos - 
          Ley de Protección de Datos Personales” disponible{' '}
          <a
            className='c-orange-0 b underline'
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.prima.com.pe/public-zone/files/2023/pdf/Solicitud-de-atencion-de-derechos-protegidos.pdf'
          >
            aquí
          </a>{' '}y deberán presentar los documentos 
          que sustenten el pedido de ser el caso.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-8 tw-mb-8@lg'>
          Atenderemos la solicitud sin costo alguno, siguiendo el procedimiento y los plazos 
          previstos en las normas de protección de datos personales.
        </p>
        <h3 className='font-family-secondary c-gray--4 tw-m-0 fw-6 tw-f-18 tw-f-18@lg tw-mb-4 tw-mb-5@lg'>
          Derecho de acceso / Información
        </h3>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Tienes derecho a ser informado sobre los datos personales incluidos en nuestra base 
          de datos, así como de las condiciones y uso que les damos.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-8 tw-mb-8@lg'>
          Te brindaremos toda la información sobre la finalidad para la cual son utilizados 
          tus datos personales, quiénes tienen acceso a ellos, en cuáles de nuestras bases 
          de datos se almacenan, así como nuestra identidad y domicilio como titulares de 
          la base de datos y, de ser el caso, del encargado de gestionar sus datos personales, 
          de las transferencias nacionales o internacionales que hacemos de los mismos, del 
          carácter obligatorio o facultativo de las respuestas a los cuestionarios que 
          entreguemos, de las consecuencias de proporcionar tus datos personales y de tu 
          negativa a hacerlo, del tiempo de conservación de los mismos y de la posibilidad 
          de ejercer los derechos que las normas te conceden y los medios previstos para ello.
        </p>
        <h3 className='font-family-secondary c-gray--4 tw-m-0 fw-6 tw-f-18 tw-f-18@lg tw-mb-4 tw-mb-5@lg'>
          Derecho de rectificación / actualización
        </h3>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-8 tw-mb-8@lg'>
          Puedes solicitar la actualización, inclusión o modificación de tus datos personales 
          cuando sean parcial o totalmente inexactos, incompletos, erróneos, falsos o 
          desactualizados. Deberás especificar los datos que deseas que sean rectificados/ 
          actualizados/ modificados/ incluidos, así como la corrección/incorporación que 
          quieras que Prima AFP realice y adjuntar los documentos de sustento aplicables.
        </p>
        <h3 className='font-family-secondary c-gray--4 tw-m-0 fw-6 tw-f-18 tw-f-18@lg tw-mb-4 tw-mb-5@lg'>
          Derecho de cancelación / supresión
        </h3>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Puedes solicitar la supresión o cancelación total o parcial de tus datos personales 
          de nuestras bases de datos si han dejado de ser necesarios para la finalidad que 
          fueron recopilados, si venció el plazo para su tratamiento o cuando el tratamiento 
          no se realice conforme a las normas de protección de datos personales.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-8 tw-mb-8@lg'>
          Ten en cuenta que tu solicitud de cancelación no procederá si mantienes una relación 
          contractual con Prima AFP y tus datos son necesarios para ejecutar dicha relación 
          contractual. Tampoco procederá cuando estemos obligados a conservar tus datos personales 
          durante los plazos previstos en las normas vigentes ni cuando sean conservados por 
          razones históricas, estadísticas o científicas de acuerdo con la legislación aplicable.
        </p>
        <h3 className='font-family-secondary c-gray--4 tw-m-0 fw-6 tw-f-18 tw-f-18@lg tw-mb-4 tw-mb-5@lg'>
          Derecho de oposición
        </h3>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-8 tw-mb-8@lg'>
          Tienes derecho a oponerte a figurar en nuestras bases de datos personales o a 
          la gestión de tu Información cuando no hayas autorizado su recopilación, por 
          haber sido tomada de fuentes de acceso al público o cuando habiendo prestado 
          tu consentimiento, acredites la existencia de motivos legítimos relativos a 
          una concreta situación personal que justifique el ejercicio de este derecho.
        </p>
        <h3 className='font-family-secondary c-gray--4 tw-m-0 fw-6 tw-f-18 tw-f-18@lg tw-mb-4 tw-mb-5@lg'>
          Derecho de revocación
        </h3>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-8 tw-mb-8@lg'>
          En cualquier momento y sin justificación previa nos puedes pedir que tus datos 
          personales dejen de ser utilizados para alguna de las finalidades previamente 
          autorizadas. Ten en consideración que tu solicitud de revocación no procederá 
          si mantienes una relación contractual con Prima AFP y tus datos son necesarios 
          para ejecutar dicha relación contractual. Tampoco procederá cuando estemos 
          obligados a conservar tus datos personales durante los plazos previstos en las 
          normas vigentes ni cuando sean conservados por razones históricas, estadísticas 
          o científicas de acuerdo con la legislación aplicable.
        </p>
        <h3 className='font-family-secondary c-gray--4 tw-m-0 fw-6 tw-f-18 tw-f-18@lg tw-mb-4 tw-mb-5@lg'>
          Requisitos
        </h3>
        <div className='c-gray--4 left tw-mb-8 tw-mb-8@lg'>
          <ul className={`w-100 bulletList-0 font-family-primary tw-f-16 tw-f-16@lg tw-mt-2`}>
            <li className='tw-mb-2'>
              El titular de datos personales deberá acreditar sus nombres y apellidos, para lo cual 
              deberá presentar una copia de su documento de identidad (DNI/CE/Pasaporte).
            </li>
            <li className='tw-mb-2'>
              Si el titular de datos personales actúa a través de un representante legal, este deberá 
              presentar un poder por Escritura Pública (debidamente inscrito) señalando que se encuentra 
              expresamente facultado para actuar en representación del titular de datos personales 
              para ejercer cualquiera de los derechos ARCO.
            </li>
            <li className='tw-mb-2'>
              El titular de datos personales o su representante deberá llenar todos los campos en 
              blanco de esta solicitud y deberá presentar los documentos que sustenten su pedido 
              de ser el caso.
            </li>
            <li>
              La solicitud que presente el titular de datos personales será atendida sin costo alguno.
            </li>
          </ul>
        </div>
        <h3 className='font-family-secondary c-gray--4 tw-m-0 fw-6 tw-f-18 tw-f-18@lg tw-mb-4 tw-mb-5@lg'>
          Información adicional
        </h3>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Prima AFP atenderá su solicitud en los siguientes plazos, contados desde la fecha de 
          presentación de la solicitud:
        </p>
        <div className='c-gray--4 left tw-mb-4 tw-mb-4@lg'>
          <ul className={`w-100 bulletList-0 font-family-primary tw-f-16 tw-f-16@lg tw-mt-2`}>
            <li className='tw-mb-2'>
              <strong>Derecho de información:</strong> 8 días hábiles.
            </li>
            <li className='tw-mb-2'>
              <strong>Derecho de acceso:</strong> 20 días hábiles.
            </li>
            <li className='tw-mb-2'>
              <strong>Derecho de rectificación, actualización, cancelación, supresión y/o oposición:</strong> 10 días hábiles.
            </li>
            <li>
              <strong>Derecho de revocatoria:</strong> 5 días hábiles.
            </li>
          </ul>
        </div>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Si la información proporcionada en esta solicitud estuviera incompleta o el titular 
          de datos personales no cumpliera con los requisitos señalados en esta solicitud, 
          Prima AFP se comunicará con el titular de datos personales en un plazo de cinco (5) 
          días hábiles contado desde la fecha de presentación de esta solicitud y formulará 
          observaciones, las cuales podrá subsanar en un plazo de (5) días hábiles. Transcurrido 
          dicho plazo sin que el titular de datos personales subsane las observaciones, se tendrá 
          por no presentada la solicitud.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Si la información proporcionada en esta solicitud fuera insuficiente o errónea de 
          forma que no permita su atención, Prima AFP podrá requerir al titular de datos 
          personales documentación adicional dentro de los siete (7) días hábiles siguientes 
          de recibida esta solicitud. El titular de datos personales tendrá un plazo de diez 
          (10) días hábiles para presentarla, de lo contrario se tendrá por no presentada la 
          solicitud.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-8@lg'>
          <strong>¿Tus derechos ARCO no fueron atendidos?</strong> Puedes presentar una reclamación ante la 
          Autoridad Nacional de Protección de Datos Personales, dirigiéndose a la Mesa de 
          Partes del Ministerio de Justicia y Derechos Humanos: Calle Scipion Llona 350, 
          Miraflores, Lima, Perú llenando el formulario publicado en el siguiente{' '}
          <a
            className='c-orange-0 b underline'
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.minjus.gob.pe/wp-content/uploads/2018/12/FORMULARIO-DE-PROCEDIMIENTO-TRILATERAL-DE-TUTELA.pdf'
          >
            enlace.
          </a>
        </p>
      </div>
    </section>
  )
}

export default EjercicioDerechos
